import LogoImage from "../../assets/Logo.png";

export default function Logo() {
  return <img width={150} src={LogoImage} alt="Logo" />;
}
